import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { postCreateContactBankAccount } from 'services/ContactService'
import { BaseErrorResponse } from 'types/beneficiaries'

export const useCreateContactBankAccountMutation = () => {
  return useMutation({
    mutationFn: postCreateContactBankAccount,
    onError: (error: BaseErrorResponse, data) => {
      if (error?.status !== 428) {
        logSentryError('Error: useAddBeneficiaryMutationPreRequest', error, data)
      }
    },
  })
}
